import React from 'react'
import { ThemeProvider } from '@mui/material/styles'

// Import brand-specific themes
import parentTheme from 'lib/themes/parentTheme'
import scienceFactoryTheme from 'lib/themes/scienceFactoryTheme'

const BrandTheme = ({ brandSettings, children }) => {
  // Define theme mappings based on brand settings
  const getTheme = () => {
    if (!brandSettings) {
      return parentTheme
    }

    const themes = {
      steveandkate: parentTheme,
      sciencefactory: scienceFactoryTheme
    }
    const brandId = brandSettings.id
    return themes[brandId] || parentTheme
  }

  const brandTheme = getTheme()

  return <ThemeProvider theme={brandTheme}>{children}</ThemeProvider>
}

export default BrandTheme
